import Checkout from "../Components/Checkout/Checkout";
import Layout from "../Layout/Layout";

const CheckoutPage = () => {
  return (
    <Layout>
      <Checkout />
    </Layout>
  );
};

export default CheckoutPage;
